import { Component, Input } from '@angular/core';
import { FormGroup, UntypedFormGroup } from '@angular/forms';
import { DropdownOption } from '@app/storybook/components/dropdown/dropdown.component';
import {
  ANNOUNCEMENT_BAR_STARTER_TEMPLATE,
  ANNOUNCEMENT_BAR_VARIABLES,
  AnnouncementBarFormShape,
  buildMessageGroup,
} from './announcement-bar.model';
import { readDisplayConditionsGroup } from '../../components/smart-cart-form-display-conditions/display-conditions.model';

type VisualTab = 'order-management' | 'timer' | 'display-conditions';

@Component({
  selector: 'smart-cart-form-announcement-bar-editor',
  templateUrl: './announcement-bar.component.html',
  styleUrls: ['./announcement-bar.component.scss'],
  standalone: false,
})
export class SmartCartFormAnnouncementBarEditorComponent {
  @Input({ required: true }) formGroup!: FormGroup<AnnouncementBarFormShape>;
  @Input() usageToken = '';

  readonly starterTemplate = ANNOUNCEMENT_BAR_STARTER_TEMPLATE;
  readonly customCodeVariables = ANNOUNCEMENT_BAR_VARIABLES;

  readonly heightOptions: DropdownOption[] = [
    { label: 'Slim', value: 'slim' },
    { label: 'Normal', value: 'normal' },
    { label: 'Wide', value: 'wide' },
  ];

  readonly rotationUnitOptions: DropdownOption[] = [
    { label: 'Minutes', value: 'minutes' },
    { label: 'Seconds', value: 'seconds' },
  ];

  readonly timerUnitOptions: DropdownOption[] = [
    { label: 'Minutes', value: 'minutes' },
    { label: 'Hours', value: 'hours' },
  ];

  activeTab: VisualTab = 'order-management';

  onTabChange(tab: VisualTab): void {
    this.activeTab = tab;
  }

  addMessage(): void {
    this.formGroup.controls.messages.push(buildMessageGroup({ html: '' }));
  }

  removeMessage(index: number): void {
    this.formGroup.controls.messages.removeAt(index);
  }

  onMessageHtmlChange(index: number, html: string): void {
    this.formGroup.controls.messages.at(index).controls.html.setValue(html);
  }

  onExpiredMessageChange(html: string): void {
    this.formGroup.controls.timer.controls.expiredMessage.setValue(html);
  }

  get displayConditionsGroup(): UntypedFormGroup | null {
    return readDisplayConditionsGroup(this.formGroup);
  }
}
